import { Button, ButtonTypeMap, type ButtonProps } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

export type MainActionButtonProps = Omit<ButtonProps, 'variant' | 'color'>;

export const MainActionButton: OverridableComponent<ButtonTypeMap<MainActionButtonProps>> = (
  props: MainActionButtonProps,
) => <Button variant="contained" color="secondary" {...props} />;
